import CollectionRow from '~/components/Content/Section/CollectionRow';
import ProductGalleryList from '~/components/Product/GalleryList';

import ProductShowcase from '../ProductShowcase';

export const types = {
  PRODUCT_KIT_CARDS: 'PRODUCT_KIT_CARDS',
  PRODUCT_KIT_GALLERY_CARD: 'PRODUCT_KIT_GALLERY_CARDS',
  VARIANT_SPOTLIGHTS: 'VARIANT_SPOTLIGHTS',
};

export function validateChild(contentType, validator) {
  const errorMessage = `Error, product presentational content model does not match type selected. Type selected: ',
  ${validator} content provided: ${contentType}`;

  let result = false;
  if ([types.PRODUCT_KIT_CARDS, types.PRODUCT_KIT_GALLERY_CARD].includes(validator)) {
    result = ['ContentfulVariant', 'ContentfulProduct', 'ContentfulKit', 'ContentfulBundle'].includes(contentType);
  } else if ([types.VARIANT_SPOTLIGHTS].includes(validator)) {
    result = ['ContentfulVariant', 'ContentfulProduct', 'ContentfulKit', 'ContentfulBundle'].includes(contentType);
  }
  if (!result) {
    console.error(errorMessage);
    return false;
  }

  return result;
}

export function renderGroupContent(group, backgroundColor) {
  if (!group) {
    return null;
  }

  if (group.type === types.PRODUCT_KIT_CARDS) {
    return (
      <CollectionRow
        itemList={group.spotlights}
        category={group.title}
        collection={group.sharedCollection}
        validateChildren={(contentType) => validateChild(contentType, types.PRODUCT_KIT_CARDS)}
        backgroundColor={backgroundColor ?? 'white'}
      />
    );
  }
  if (group.type === types.PRODUCT_KIT_GALLERY_CARD) {
    return (
      <ProductGalleryList
        collection={group.sharedCollection}
        fromProductSection={true}
        validateChildren={(contentType) => validateChild(contentType, types.PRODUCT_KIT_CARDS)}
        presentationalProductCards={group.spotlights}
        backgroundColor={backgroundColor}
      />
    );
  }
  if (group.type === types.VARIANT_SPOTLIGHTS) {
    return (
      <ProductShowcase
        showcase={group}
        validateChildren={(contentType) => validateChild(contentType, types.VARIANT_SPOTLIGHTS)}
      />
    );
  }
  return null;
}
